
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lab-pack-services",
      function () {
        return require("private-next-pages/lab-pack-services/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lab-pack-services"])
      });
    }
  